import { useAccountCompanyId } from 'application/hooks';

import { useBillingCompanyBillingInfoQuery } from '@shared/api/graphql/generated';
import { FetchPolicyKeys } from '@shared/api/graphql/types';

import DateUtils from '@zvuk-b2b/react-uikit/toolkit/DateUtils';

interface UseNextDate {
  nextBillingDate: string;
  hasTrialLicenses: boolean;
  isWaitPaymentLicense: boolean;
  isGraceLicense: boolean;
  licensesCount: number;
  formatNextBillingDate?: string;
}

const useNextDate = (): UseNextDate | null => {
  const companyId = useAccountCompanyId();

  const { data: billingInfoData, loading: billingInfoLoading } = useBillingCompanyBillingInfoQuery({
    variables: {
      companyId,
    },
    fetchPolicy: FetchPolicyKeys.CACHE_AND_NETWORK,
  });

  if (!billingInfoData || !billingInfoData.result || billingInfoLoading) {
    return null;
  }

  const { nextBillingDate, renewableLicenses, hasTrialLicenses, isWaitPaymentLicense, isGraceLicense } =
    billingInfoData.result;

  const licensesCount = renewableLicenses.length;
  const formatNextBillingDate = nextBillingDate
    ? DateUtils.getFormatDateFrom(new Date(nextBillingDate), 'dd.MM.yyyy')
    : undefined;

  return {
    nextBillingDate,
    hasTrialLicenses,
    isWaitPaymentLicense: Boolean(isWaitPaymentLicense),
    isGraceLicense: Boolean(isGraceLicense),
    licensesCount,
    formatNextBillingDate,
  };
};

export default useNextDate;
